import Vue from 'vue'
import { Eva } from '@/utils/eva'

Vue.prototype.$eva = new Eva()
